import React, { useState } from 'react';
import './Publications.css';

const Publications = () => {
  const [filter, setFilter] = useState('all');

  const publicationsData = [
    {
      type: 'Book (Editor)',
      title: 'Advances in Tropical Meteorology: Meteorology and National Development',
      authors: 'Rattan K. Datta (Editor)',
      journal: 'Concept Publishing Company, New Delhi',
      year: '1996',
      volume: '-',
      pages: 'xiv + 470',
      isbn: '8170225329 / 9788170225324',
      description: 'Proceedings of TROPMET-93 symposium with 54 articles in 10 sections covering meteorological advances and applications'
    },
    {
      type: 'Book (Editor)',
      title: 'Coastal Ecosystems: Hazards, Management and Rehabilitation',
      authors: 'Rattan K. Datta (Editor)',
      journal: 'Daya Publishing House, Delhi (NAM S&T Centre)',
      year: '2008',
      volume: '-',
      pages: '363',
      isbn: '8170355575 / 9788170355571',
      description: '26 expert papers on coastal hazards, tsunamis, cyclones with GIS applications'
    },
    {
      type: 'Journal Article',
      title: 'NIMBLE@ITCEcnoGrid: A Grid in Research Domain for Weather Forecasting',
      authors: 'Vijay Dhir, Dr. Rattan K Datta, Dr. Maitreyee Dutta',
      journal: 'International Journal of Grid Computing & Applications (IJGCA)',
      year: '2011',
      volume: 'Vol.2, No.4',
      pages: '37-47',
      isbn: 'DOI: 10.5121/ijgca.2011.2404',
      description: 'Grid computing applications for meteorological forecasting'
    },
    {
      type: 'Journal Article',
      title: 'NIMBLE@ITCECNOGRID VS ALCHEMI.NET: A Performance Comparison',
      authors: 'Vijay Dhir, Dr. Rattan K Datta, Dr. Maitreyee Dutta',
      journal: 'International Journal of Distributed and Parallel Systems (IJDPS)',
      year: '2011',
      volume: 'Vol.2, No.6',
      pages: '87-97',
      isbn: 'DOI: 10.5121/ijdps.2011.2608',
      description: 'Comparative analysis of grid computing frameworks'
    },
    {
      type: 'Journal Article',
      title: 'Statistical Usage Testing at Different Levels of Testing',
      authors: 'K. Kaur, S.K. Khatri, A. Mishra, R. Datta',
      journal: 'Journal of Universal Computer Science (JUCS)',
      year: '2018',
      volume: 'Vol.24, Issue 12',
      pages: '1800-1820',
      isbn: 'DOI: 10.3217/jucs-024-12-1800',
      description: 'Research on software testing methodologies'
    },
    {
      type: 'Journal Article',
      title: 'Grid Job Scheduling - A Detailed Study',
      authors: 'Vijay Dhir, Dr. Rattan K Datta, Dr.Maitreyee Dutta',
      journal: 'International Journal of Innovative Research in Science, Engineering & Technology (IJARETY)',
      year: '2013',
      volume: 'Vol:2, Issue: 10',
      pages: 'Not specified',
      isbn: '-',
      description: 'Study on scheduling algorithms in grid computing'
    },
    {
      type: 'Journal Article',
      title: 'NIMBLE@ITCECNOGRID Novel Toolkit for Computing Weather Forecasting, Pi and Factorization Intensive Problems',
      authors: 'Vijay Dhir, Rattan K Datta, Maitreyee Dutta',
      journal: 'International Journal of Computer Engineering & Technology (IJCET)',
      year: '2012',
      volume: 'Vol:3 Issue:3',
      pages: '320-339',
      isbn: 'IJCET_03_03_033',
      description: 'Computational toolkit for meteorological applications'
    },
    {
      type: 'Journal Article',
      title: 'Predicting the formation of tornadoes using association rule mining by studying a real life tornado event: Georgia, USA January, 2013',
      authors: 'Gurbrinder Kaur, Rattan K. Datta',
      journal: 'MAUSAM',
      year: '2021',
      volume: 'vol. 72, no. 4',
      pages: '813–820',
      isbn: 'DOI: 10.54302/mausam.v72i4.3549',
      description: 'Machine learning approach to tornado prediction'
    },
    {
      type: 'Journal Article',
      title: 'Using Statistical Usage Testing in Conjunction with other black Box Testing Techniques',
      authors: 'S. K. Khatri, K. Kaur, R. Datta',
      journal: 'International Journal of Reliability, Quality and Safety Engineering',
      year: '2015',
      volume: 'Vol. 22, Number 1',
      pages: '1550004',
      isbn: 'DOI: 10.1142/S0218539315500047',
      description: 'Software testing methodology research'
    },
    {
      type: 'Preprint',
      title: 'Nimble@ITCEcnoGrid: A Grid in Research Domain for Weather Forecasting',
      authors: 'Vijay Dhir, Rattan K. Datta, Maitreyee Dutta',
      journal: 'arXiv preprint',
      year: '2012',
      volume: 'arXiv:1201.2288',
      pages: '-',
      isbn: '-',
      description: 'Preprint version of grid computing research'
    },
    {
      type: 'Book Chapter',
      title: 'Certain aspects of monsoonal precipitation dynamics over Lake Victoria',
      authors: 'R. K. Datta',
      journal: 'Monsoon Dynamics (Cambridge University Press)',
      year: '1981',
      volume: 'Chapter 22',
      pages: '333-350',
      isbn: '9780511897580',
      description: 'Chapter in Cambridge University Press book on monsoon dynamics'
    }
  ];

  const filteredPublications = filter === 'all' 
    ? publicationsData 
    : publicationsData.filter(pub => pub.type === filter);

  const getUniqueTypes = () => {
    const types = publicationsData.map(pub => pub.type);
    return ['all', ...new Set(types)];
  };

  return (
    <div className="publications-container">
      <div className="publications-header">
        <h1>Publications by Dr. Rattan K Datta</h1>
        <p className="subtitle">Complete List of Books, Research Papers, and Academic Contributions</p>

        <div className="filter-section">
          <label htmlFor="publication-filter">Filter by Type:</label>
          <select 
            id="publication-filter"
            value={filter} 
            onChange={(e) => setFilter(e.target.value)}
            className="filter-select"
          >
            {getUniqueTypes().map(type => (
              <option key={type} value={type}>
                {type === 'all' ? 'All Publications' : type}
              </option>
            ))}
          </select>
        </div>

        <div className="stats-section">
          <div className="stat-item">
            <span className="stat-number">{publicationsData.length}</span>
            <span className="stat-label">Total Publications</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">40+</span>
            <span className="stat-label">Years of Research</span>
          </div>
          {/* <div className="stat-item">
            <span className="stat-number">200+</span>
            <span className="stat-label">Claimed Publications</span>
          </div> */}
        </div>
      </div>

      <div className="publications-table-container">
        <table className="publications-table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Title</th>
              <th>Authors</th>
              <th>Journal/Publisher</th>
              <th>Year</th>
              <th>Volume</th>
              <th>Pages</th>
              <th>ISBN/DOI</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {filteredPublications.map((publication, index) => (
              <tr key={index} className={`publication-row ${publication.type.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}>
                <td className="type-cell">
                  <span className={`type-badge ${publication.type.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}>
                    {publication.type}
                  </span>
                </td>
                <td className="title-cell">
                  <strong>{publication.title}</strong>
                </td>
                <td className="authors-cell">{publication.authors}</td>
                <td className="journal-cell">{publication.journal}</td>
                <td className="year-cell">{publication.year}</td>
                <td className="volume-cell">{publication.volume}</td>
                <td className="pages-cell">{publication.pages}</td>
                <td className="isbn-cell">{publication.isbn}</td>
                <td className="description-cell">{publication.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="publications-footer">
        {/* <p><strong>Note:</strong> Dr. Rattan K Datta has published approximately 200 research papers throughout his career. This list represents the publications identified through comprehensive research.</p> */}
        <div className="author-info">
          <h3>About Dr. Rattan K Datta</h3>
          <ul>
            <li>Ph.D from IIT Delhi on "Monsoon Dynamics & Modelling"</li>
            <li>CEO & Director, MERIT, New Delhi</li>
            <li>Retired Adviser, Department of Science & Technology, Government of India</li>
            <li>Former Advisor, Meteorological Department, Government of India</li>
            <li>Email: rkdatta_in@yahoo.com</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Publications;
